import { Frame } from "scenejs";
import _ from 'lodash';

export function getStylesForLayout(layout, breakpoint, container) {
  var widgetStyle = new Frame(layout).toCSSObject();

  if (container) {
    const minWidth = _.get(container, `properties.${breakpoint}.container.minWidth`);
    const alignment = _.get(container, `properties.${breakpoint}.container.alignment.position`) || _.get(container, `properties.${breakpoint}.container.alignment`, 'center');

    var multiplier = 0.5;
    switch (alignment) {
      case 'left':
        multiplier = 0;
        break;

      case 'right':
        multiplier = 1;
        break;

      case 'center':
      default:
        multiplier = 0.5;
        break;
    }

    widgetStyle = {
      ...widgetStyle,
      marginLeft: !minWidth ? '0px' : `calc((100% - ${minWidth}px) * ${multiplier})`
    }
  }

  return widgetStyle;
}

export function colorToString(color) {
  if (!color) {
    return "inherit";
  }

  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;;
}

